import { render } from "./vsharedvcexfactoryZijinfang.vue?vue&type=template&id=06941782&scoped=true"
import script from "./vsharedvcexfactoryZijinfang.vue?vue&type=script&lang=js"
export * from "./vsharedvcexfactoryZijinfang.vue?vue&type=script&lang=js"

import "./vsharedvcexfactoryZijinfang.vue?vue&type=style&index=0&id=06941782&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06941782"]])

export default __exports__